<template>
  <div>
    <div class="testArea">
      <MapByGeo v-model="place"
                :zoom="zoom"
                :latlng="latlng"
                :draggableMarker="true">
      </MapByGeo>
    </div>
    <div class="testArea">
      {{place}}
    </div>
    <div class="testArea">
      <el-form class="main-form geoForm">
        <el-form-item>
          <span class="label">Buscar por dirección</span>
          <el-tooltip placement="top">
            <div slot="content">A veces errores en la comuna, region o<br/>
              faltas ortográficas afectan la búsqueda del punto.<br/>
              <span class="focus small">
                    ** Busca la dirección re-escribiendo la información recibida. **
                    </span>
            </div>
            <i class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
          </el-tooltip>
          <el-form>
            <InputSearchAddress v-model="place"
                                    :disabledForm="switch_on"
                                    @input="setZoom"
                                    @sendPlaceToParent="setPlace"></InputSearchAddress>
          </el-form>
        </el-form-item>
        <el-form-item>
          <span class="label">Buscar por latitud, longitud</span>
          <el-tooltip placement="top">
            <div slot="content">¿Sabes la locación del punto exacto?<br/>
              pega la latitud y longitud siguiento el formato<br/>
              <span class="focus small">
                    ** El formato al pegar es 'lat, lng' **
                  </span>
            </div>
            <i class="tooltipStyle fas fa-info-circle" aria-hidden="true"></i>
          </el-tooltip>
          <el-form>
            <InputSearchByPosition :value="place"
                                @setPosition="setPlaceByLocation"></InputSearchByPosition>
          </el-form>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import MapByGeo from '../components/maps/MapByGeo.vue';
import InputSearchAddress from '../components/maps/InputSearchAddress.vue';
import InputSearchByPosition from '../components/maps/InputSearchByPosition.vue';

export default {
  props: {
    windowWidth: {
      type: Number,
    },
  },
  name: 'TestGeo',
  components: {
    MapByGeo,
    InputSearchAddress,
    InputSearchByPosition,
  },
  data() {
    return {
      socList: [],
      sectorList: [
        {
          id: 1,
          name: 'Sector 1',
          region_id: 4,
          packageType_id: 2,
          enterprise_id: 1,
          patentList: [
            1,
            2,
          ],
          suborderList: [
            144034900287,
            100000000232,
          ],
        },
        {
          id: 2,
          name: 'Sector 2',
          region_id: 3,
          packageType_id: 1,
          enterprise_id: 2,
          patentList: [
            3,
            4,
          ],
          suborderList: [
            144043295533,
            144043296201,
          ],
        },
        {
          id: 3,
          name: 'Sector 3',
          region_id: 7,
          packageType_id: 4,
          enterprise_id: 5,
          patentList: [
            6,
            5,
          ],
          suborderList: [
            144006030487,
            144034928780,
          ],
        },
      ],
      socs: [
        {
          dp_id: 1,
          geostate: 4,
          last_state: 5,
          last_state_name: 'Terminado',
          package_type_id: 5,
          package_type_name: 'MM',
          requested_at: '2019-08-12T00:00:00Z',
          locality: 'SAN JOAQUIN',
          verified: true,
          suborder: 144034791001,
          checked: false,
        },
        {
          dp_id: 2,
          geostate: 4,
          last_state: 2,
          last_state_name: 'Planificado',
          package_type_id: 3,
          package_type_name: 'BT',
          requested_at: '2019-08-12T00:00:00Z',
          locality: 'SAN JOAQUIN',
          verified: true,
          suborder: 144034791002,
          checked: false,
        },
        {
          dp_id: 3,
          geostate: 4,
          last_state: 2,
          last_state_name: 'Planificado',
          package_type_id: 3,
          package_type_name: 'BT',
          requested_at: '2019-08-12T00:00:00Z',
          locality: 'SAN JOAQUIN',
          verified: true,
          suborder: 144034791003,
          checked: false,
        },
        {
          dp_id: 83,
          geostate: 4,
          last_state: 2,
          last_state_name: 'Planificado',
          package_type_id: 3,
          package_type_name: 'BT',
          requested_at: '2019-08-12T00:00:00Z',
          locality: 'SAN JOAQUIN',
          verified: true,
          suborder: 144034791029,
        },
      ],
      zoom: 8,
      location: '',
      latlng: {},
      switch_on: false,
      initialAddress: '',
      place: {
        address: '',
        position: {
          lat: -33.435774,
          lng: -70.660690,
        },
        commune: '',
        locality: '',
        route: '',
        street_number: '',
      },
    };
  },
  methods: {
    GetSocs() {
      this.$emit('GetSocs', this.socs);
    },
    setZoom() {
      this.zoom = 14;
    },
    setPlaceByLocation(position) {
      this.latlng = JSON.parse(JSON.stringify(position));
    },
    /*
    deleteEvent(soc) {
      this.socs = this.socs.filter(s => s.suborder.toString() !== soc.toString());
    },
    */
    emulateFilter(soc) {
      return soc.package_type_id === 3;
    },
    /*
    removeSelected() {
      this.socs = this.socs
      .filter(s => this.socList.findIndex(val => val.toString() === s.suborder.toString()) === -1);
    },
    */
  },
  beforeMount() {
  },
  created() {
  },
  beforeDestroy() {
  },
  mounted() {
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
  .testArea {
    margin: 3rem;
    padding: 1rem;
    border: 2px solid red;
  }
  ul {
    max-height: 250px;
    min-height: 100px;
    overflow-y: scroll;
    overflow-x: hidden;
    border: 1px solid #EBEEF5;
    padding-left: 10px;
  }
  li {
    font-family: "Lato", sans-serif;
    height: 30px;
    font-size: 14px;
    width: 95%;
    list-style-type: none;
    border-bottom: 1px solid #EBEEF5;
  }
  .tooltipStyle {
    color: #AAD500;
    font-size: 16px;
    vertical-align: bottom;
  }
  .label {
    text-transform: uppercase;
    font-size: 10px;
    color: #606266;
    display: inline-block;
    text-align: left;
    line-height: 12px;
    vertical-align: bottom;
    font-weight: 700;
  }
  .focus {
    text-transform: uppercase;
    font-weight: 900;
    color: #AAD500;
    &.small {
      display: block;
      font-style: italic;
      margin-top: 0.5em;
      font-size: 0.85em;
    }
  }
  .iconsSitesContainer {
    display: flex;
  }
  .iconSiteContainer {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
    }
  }
  .fas.fa-info-circle {
    font-size: 13px;
    margin-left: 5px;
  }
  .el-input {
    margin-top: 1em;
  }

</style>
